// Injected by build.mjs (esbuild "define"); "dev" when running from source (tests, tsx).
declare const __VERSION__: string;
declare const __BUILD__: string;
export const VERSION: string = typeof __VERSION__ === "string" ? __VERSION__ : "dev";
export const BUILD: string = typeof __BUILD__ === "string" ? __BUILD__ : "";
